import type { CacheRowResult } from './observation-repository';

// portal_cache staleness gate: rows older than this many hours must be re-fetched.
const PORTAL_CACHE_FRESHNESS_HOURS = 6;

/** True when the scraper wrote `upd` less than the window before `now`; exactly that old is stale. */
export function isFreshUpd(upd: string | null, now: number): boolean {
  if (upd === null) return false;
  return (now - Date.parse(upd)) / 3_600_000 < PORTAL_CACHE_FRESHNESS_HOURS;
}

/** True when the row carries a payload and its `upd` is fresh at `now`. */
export function isFreshRow(row: CacheRowResult | undefined, now: number): boolean {
  return row?.hasPayload === true && isFreshUpd(row.upd, now);
}
